import { mergeParams } from '../mergeParams';

describe('mergeParams', () => {
  it('merges sections that share the same rootAttributeKey', () => {
    const params = {
      details: { some_field: 'value', another_field: 'other' },
    };
    const priceAttributes = {
      details: { price_rating: 5, discounts: ['senior'] },
    };

    const result = mergeParams(params, priceAttributes);

    expect(result.details).toEqual({
      some_field: 'value',
      another_field: 'other',
      price_rating: 5,
      discounts: ['senior'],
    });
  });

  it('does not lose universal attributes when price attributes are merged', () => {
    const params = {
      details: { wifi: true, wheelchair: false },
    };

    const result = mergeParams(params, { details: { price_rating: 3 } });

    expect(result.details.wifi).toBe(true);
    expect(result.details.wheelchair).toBe(false);
    expect(result.details.price_rating).toBe(3);
  });

  it('does not lose price attributes when universal attributes are merged', () => {
    const params = {
      details: { price_rating: 3, discounts: ['military'] },
    };

    const result = mergeParams(params, { details: { wifi: true } });

    expect(result.details.price_rating).toBe(3);
    expect(result.details.discounts).toEqual(['military']);
    expect(result.details.wifi).toBe(true);
  });

  it('returns original params when attributes is undefined', () => {
    const params = { details: { wifi: true } };
    const result = mergeParams(params, undefined);
    expect(result).toBe(params);
  });

  it('replaces array values instead of merging them', () => {
    const params = { details: { discounts: ['senior'] } };
    const result = mergeParams(params, { details: { discounts: ['military', 'student'] } });
    expect(result.details.discounts).toEqual(['military', 'student']);
  });

  it('handles non-overlapping rootAttributeKeys with simple assignment', () => {
    const params = { details: { wifi: true } };
    const result = mergeParams(params, { parking_details: { covered: true } });

    expect(result.details).toEqual({ wifi: true });
    expect(result.parking_details).toEqual({ covered: true });
  });

  it('does not mutate the original params', () => {
    const params = { details: { wifi: true } };
    mergeParams(params, { details: { price_rating: 3 } });
    expect(params.details).toEqual({ wifi: true });
  });

  it('deep merges nested objects 2+ levels without overwriting sibling keys', () => {
    const params = {
      details: {
        hours: { monday: '9-5', tuesday: '9-5' },
        contact: { phone: '555-1234' },
      },
    };
    const attributes = {
      details: {
        hours: { wednesday: '10-4' },
      },
    };

    const result = mergeParams(params, attributes);

    expect(result.details.hours).toEqual({
      monday: '9-5',
      tuesday: '9-5',
      wednesday: '10-4',
    });
    expect(result.details.contact).toEqual({ phone: '555-1234' });
  });

  it('clones nested arrays and objects so they are not shared by reference', () => {
    const sourceArray = ['senior', 'military'];
    const sourceObj = { monday: '9-5' };
    const attributes = {
      details: { discounts: sourceArray, hours: sourceObj },
    };

    const result = mergeParams({}, attributes);

    expect(result.details.discounts).toEqual(sourceArray);
    expect(result.details.discounts).not.toBe(sourceArray);
    expect(result.details.hours).toEqual(sourceObj);
    expect(result.details.hours).not.toBe(sourceObj);
  });
});
